<template>
  <div class="org-node">
    <div
      class="org-card"
      :class="[`org-card--${node.kind}`, { 'org-card--selected': selectedRef === node.refCode, 'org-card--me': node.isMe }]"
      @click="$emit('select', node)"
    >
      <span v-if="node.isMe" class="org-card-me-badge">ตัวคุณ</span>
      <div class="org-card-icon">
        <v-icon size="14" color="white">{{ kindIcon }}</v-icon>
      </div>
      <div class="org-card-body">
        <div class="org-card-name">{{ node.displayName }}</div>
        <div class="org-card-username" v-if="node.username">@{{ node.username }}</div>
        <div class="org-card-ref">{{ node.refCode }}</div>
        <div v-if="node.pack" class="org-card-pack" :style="{ color: packColor(node.pack), background: packBg(node.pack) }">
          <v-icon :color="packColor(node.pack)" size="10" style="margin-right:3px">{{ packIcon(node.pack) }}</v-icon>{{ node.pack }}
        </div>
      </div>
      <div class="org-card-balance">{{ formatBal(node.commissionBalance) }}</div>
    </div>

    <template v-if="node.children && node.children.length">
      <div class="org-vline-down" />
      <div class="org-children-row">
        <div class="org-child-col" v-for="child in node.children" :key="child.refCode">
          <div class="org-vline-up" />
          <org-tree-node
            :node="child"
            :selected-ref="selectedRef"
            v-on="$listeners"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { packTheme } from "@/utils/packTheme";

export default {
  name: "OrgTreeNode",
  props: {
    node: { type: Object, required: true },
    selectedRef: { type: String, default: null },
  },
  computed: {
    kindIcon() {
      if (this.node.kind === "seller") return "mdi-store";
      if (this.node.kind === "rider") return "mdi-motorbike";
      return "mdi-account";
    },
  },
  methods: {
    packIcon(name) { return packTheme(name).icon; },
    packColor(name) { return packTheme(name).color; },
    packBg(name) { return packTheme(name).bg; },
    formatBal(n) {
      if (!n) return "0";
      return Number(n).toLocaleString("th-TH", { maximumFractionDigits: 0 });
    },
  },
};
</script>

<style>
.org-node { display: flex; flex-direction: column; align-items: center; }

.org-card {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 12px; border-radius: 12px;
  border: 2px solid #E5E7EB; background: #fff;
  cursor: pointer; transition: box-shadow 0.15s, border-color 0.15s;
  min-width: 160px; max-width: 200px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  user-select: none;
}
.org-card:hover { box-shadow: 0 4px 14px rgba(0,0,0,0.12); }
.org-card--selected {
  border-color: #F59E0B !important;
  box-shadow: 0 0 0 3px #FEF3C7, 0 4px 14px rgba(245,158,11,0.2) !important;
}
.org-card { position: relative; }
.org-card--me {
  border-color: #2563EB !important;
  background: #EFF6FF !important;
  box-shadow: 0 0 0 3px #DBEAFE, 0 4px 14px rgba(37,99,235,0.22) !important;
}
.org-card-me-badge {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: #2563EB;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 10px;
  border-radius: 10px;
  letter-spacing: 0.04em;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(37,99,235,0.3);
}
.org-card--user   .org-card-icon { background: #8B5CF6; }
.org-card--seller .org-card-icon { background: #3B82F6; }
.org-card--rider  .org-card-icon { background: #10B981; }

.org-card-icon {
  width: 28px; height: 28px; min-width: 28px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  background: #9CA3AF;
}
.org-card-body { flex: 1; min-width: 0; }
.org-card-name     { font-size: 12px; font-weight: 700; color: #111827; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.org-card-username { font-size: 10px; color: #6B7280; margin-top: 1px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.org-card-ref      { font-size: 10px; color: #F59E0B; font-weight: 600; margin-top: 1px; }
.org-card-balance { font-size: 11px; font-weight: 700; color: #F59E0B; white-space: nowrap; }
.org-card-pack {
  display: inline-flex; align-items: center;
  font-size: 9px; font-weight: 700;
  padding: 1px 6px; border-radius: 10px;
  margin-top: 3px; white-space: nowrap;
}

.org-vline-down { width: 2px; height: 20px; background: #E5E7EB; }
.org-vline-up   { width: 2px; height: 20px; background: #E5E7EB; }

.org-children-row { display: flex; }

.org-child-col {
  display: flex; flex-direction: column; align-items: center;
  padding: 0 16px; position: relative;
}
.org-child-col::before {
  content: ''; position: absolute; top: 0; height: 2px; background: #E5E7EB;
}
.org-child-col:first-child::before  { left: 50%; right: 0; }
.org-child-col:last-child::before   { left: 0; right: 50%; }
.org-child-col:not(:first-child):not(:last-child)::before { left: 0; right: 0; }
.org-child-col:only-child::before   { display: none; }
</style>
